<template>
    <ChartItem ref="chart"></ChartItem>
</template>

<script>
import ChartItem from "@/components/chart-item";


export default {
	name: "volume-statistics",
	components: {ChartItem},
	data() {
		const width = document.body.clientWidth
		let is_w = width / 1920;is_w=is_w>1?1:is_w
		return {
			el: null,
			config: {
				grid:{
					left:16/is_w+'%',
					right:12/is_w+'%',
					top:'30%',
					bottom:'16%',
				},
				legend: {
					data: [
						{
							name: '交易额',
							color: '#e4ac3e'
						},
						{
							name: '订单数',
							color: '#c19745'
						}
					],
					top: 20,
					textStyle: {
						fontFamily: 'Arial',
						fontSize: is_w*18,
						fill: '#fff'
					}
				},
				xAxis: {
					data: ['2025/1/31', '2025/2/1', '2025/2/2', '2025/2/3', '2025/2/4', '2025/2/5', '2025/2/6'],
					axisLabel: {
						style: {


							textBaseline: 'top',
							fill: '#cdcac3',
						}
					},
					axisLine: {
						style: {
							stroke: '#cdcac3',
							lineWidth: 1
						}
					},
					nameTextStyle: {
						fill: '#fff',
						fontSize: is_w*16
					},
					axisTick: {
						style: {
							stroke: '#cdcac3',
							lineWidth: 1
						}
					}
				},
				yAxis: [

					{
						name: '交易额',
						data: 'value',
						min: 0,
						max: 60,
						interval: 10,
						axisLine: {
							style: {
								stroke: 'rgba(0,0,0,0)',
								lineWidth: 1
							}
						},
						splitLine: {
							style:{
								stroke: 'rgba(255,255,255,0.3)',
                            }
                        },
						axisLabel: {
							formatter: '{value} 万元',
							style: {
								fill: '#cdcac3',
							}
						},
						nameTextStyle: {
							fill: '#fff',
							fontSize: 16
						},
						axisTick: {
							show: false
						}
					},
					{
						name: '订单数',
						data: 'value',
						position: 'right',
						min: 0,
						max: 800,
						interval: 200,
						splitLine: {
							show: false
						},
						axisLine: {
							style: {
								stroke: 'rgba(0,0,0,0)',
								lineWidth: 1
							}
						},
						axisLabel: {
							formatter: '{value} 单',
							style: {
								fill: '#cdcac3',
							}
						},
						nameTextStyle: {
							fill: '#fff',
							fontSize: 16
						},
						axisTick: {
							show: false
						}
					}

				],
				series: [
					{
						name: '交易额',
						data: [
							43, 28, 36, 14, 50, 28, 55

						],
						type: 'line',
						lineStyle: {
							stroke: '#e8c072',
							lineWidth: 2
						},
						smooth: true,
						linePoint: {
							style: {
								stroke: '#f19745'
							}
						},
						lineArea: {
							show: true,
							gradient: ['#e8c072', 'rgba(232,192,114,0)']
						},
						animationCurve: 'easeOutBounce'
					},
					{
						name: '订单数',
						yAxisIndex: 1,
						data: [
							775, 525, 490, 730, 345, 365, 688

						],
						type: 'bar',
						barWidth: '40%',
						gradient: {
							//color: ['#e4ac3e', '#3b3734'],
							color: ['#e4ac3e', 'rgba(247,191,80,0.1)'],
						},
						animationCurve: 'easeOutBounce'
					},

				]
			}
		}
	},
	methods: {
		setConfig(option = {}) {
            let config = {...this.config, ...option}

			if (this.el) {
				this.el.setConfig(config)
			}else {
				this.el = this.$refs.chart
				this.el.setConfig(config)
            }
		}

	},
	mounted() {
	}
}
</script>

<style scoped>

</style>
